define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'readingiq-src/js/config/user-permissions',
  'readingiq-src/riq_frame_com_en/js/ui-text'
], function(aoflModules, userPermissions, userText) {
  'use strict';
  var aclServiceImpl = function aclServiceImpl($state) {
    var _this = this;
    var storeService = aoflModules.store;
    var apiUserRoleMapping = {
      parent_standard_access_1: {
        master: 'PARENT_FULL',
        reader: 'CHILD_PAID',
        reader_ems_linked: 'CHILD_PAID_EMS_LINKED',
        reader_class_linked: 'CHILD_PAID_CLASS_LINKED'
      },
      parent_standard_access_2: {
        master: 'PARENT_FULL',
        reader: 'CHILD_PAID_LIMITED',
        reader_ems_linked: 'CHILD_PAID_LIMITED_EMS_LINKED',
        reader_class_linked: 'CHILD_PAID_LIMITED_CLASS_LINKED'
      },
      parent_standard_access_3: {
        master: 'PARENT_FULL',
        reader: 'CHILD_PAID',
        reader_class_linked: 'CHILD_PAID_CLASS_LINKED'
      },
      teacher_standard_access_1: {
        master: 'TEACHER',
        reader: 'CHILD_AT_SCHOOL',
        reader_class_linked: 'CHILD_AT_SCHOOL'
      },
      parent_limited_access_1: {
        master: 'PARENT_FREE',
        reader: 'CHILD_FREE',
        reader_class_linked: 'CHILD_FREE_CLASS_LINKED'
      },
      teacher_limited_access_1: {
        master: 'TEACHER_EMS',
        reader: 'EMS_STUDENT_AT_SCHOOL',
        reader_class_linked: 'EMS_STUDENT_AT_SCHOOL'
      }
    };

    const userPreferenceByRole = {
      PARENT_FULL: {
        homepage: {
          route: 'library_en',
          link: '/home'
        },
        // no route for logout
        logout: {
          link: '/'
        },
        fallbackPage: {
          route: 'select_profile_en',
          link: '/select-user'
        }
      },
      TEACHER: {
        homepage: {
          route: 'class_login_en',
          link: '/class-login'
        },
        // no route for logout
        logout: {
          link: '/teachers'
        },
        fallbackPage: {
          route: 'class_login_en',
          link: '/class-login'
        }
      }
    };
    userPreferenceByRole.PARENT_FREE = userPreferenceByRole.PARENT_FULL;
    userPreferenceByRole.TEACHER_EMS = userPreferenceByRole.TEACHER;

    function getUserRole(state = storeService.getState()) {
      return state.user && state.user.role ? state.user.role : '';
    }

    function getMappedUserRole(state) {
      state = state || storeService.getState();
      var mappedRoles = apiUserRoleMapping[getUserRole(state)] || {};
      var isOnboarding = $state.current.name.indexOf('onboarding') > -1;
      var isClassLogin = $state.current.name.indexOf('class_login') > -1;
      var isGroupOwner = state.profile && state.profile.isGroupOwner;
      var roleArr = state.profile.role || [];
      var isClassLinked =
        state.profile.role &&
        roleArr.filter(function(role) {
          return role.type === 'student';
        })[0];
      var isEmsStudent = roleArr.some(function(role) {
        return role.type === 'ems_student';
      });
      var role = '';
      if (
        state.user.userUuid === state.profile.userUuid &&
        (isGroupOwner || isClassLogin || isOnboarding)
      ) {
        role = mappedRoles.master;
      } else if (isClassLinked) {
        role = mappedRoles.reader_class_linked;
      } else if (isEmsStudent) {
        role = mappedRoles.reader_ems_linked || mappedRoles.reader;
      } else {
        role = mappedRoles.reader;
      }
      return role;
    }

    /**
     * Check if current user has the permission to do an action
     * @param {String} permission The permission key the user should be allowed to access
     * @return {Boolean} true if user can, false if not
     */
    var can = function can(permission) {
      const state = storeService.getState();
      const _permissions = state.profile.$permissions;
      if (Array.isArray(permission)) {
        return permission.every(permission =>
          _permissions.includes(permission)
        );
      }
      return _permissions.indexOf(permission) !== -1;
    };

    /**
     * Get the ui text for a specific user type
     * @return {Object} the object of ui text based on current user's role
     */
    var getUserText = function getUserText() {
      var role = getMappedUserRole();
      var _text = userText.getUserText(role);
      return _text;
    };

    var canViewState = function(toState) {
      var idx = toState.name.lastIndexOf('_');
      if (idx > 0) {
        var statePermissionKey = 'view_' + toState.name.substring(0, idx);
        return can(statePermissionKey);
      }
      return false;
    };

    var ifCan = function(permission, callback) {
      return can(permission) && typeof callback === 'function' && callback();
    };

    function getApiUserRoleMapping() {
      return apiUserRoleMapping;
    }

    const getUserPreferences = function getUserPreferences(role) {
      return (
        userPreferenceByRole[role] ||
        console.warn('could not load user preferences', role) ||
        null
      );
    };

    _this.canViewState = canViewState;
    _this.can = can;
    _this.getUserText = getUserText;
    _this.ifCan = ifCan;
    _this.addPermissions = userPermissions.addPermissions;
    _this.getRolePermissions = userPermissions.getUserPermissions;
    _this.getApiUserRoleMapping = getApiUserRoleMapping;
    _this.getUserRole = getUserRole;
    _this.getMappedUserRole = getMappedUserRole;
    _this.getUserPreferences = getUserPreferences;
  };

  return aclServiceImpl;
});
